// extracted by mini-css-extract-plugin
export default {"root":"Main-root-b5Q"};